<template>
  <div class="SelectInputs temr">
    <span
      :class="`title ${params.field}`"
      :style="{ width: labelWidth }"
      v-if="params.title"
    >{{ params.title }}</span>
    <input
      :type="type"
      v-model="col"
      class="Input"
      @input="
        (e) => {
          handleinput(e);
        }"
      @focus="focusHandler"
      :disabled="params.props.disabled"
      :placeholder="params.props.placeholder"
      :maxLength="params.props.maxLength"
    />
    <van-icon
      v-if="allowClearHandler && col"
      @click="clickDelete"
      class="cross"
      name="cross"
    />
    <div
      v-if="(error  && !flag) ||  col !== ''"
      class="error-message"
    >{{ error }}</div>
    <div
      class="SelectInput"
      v-if="flag"
    >
      <div
        v-for="e in suggestList"
        class="suggestList"
        :key="e.eid"
        @click="handleSuggest(e)"
      >
        <div
          class="suggestName"
          v-html="e.name.replace(new RegExp(`${col}`), `<span style='color:#F56446; font-size: 14px;'>${col}</span>`)"
        >
        </div>
        <div class="suggestno">{{ e.credit_no }}
          <span class="suggestnoText">{{e.userType == '1' ? '法人' : '' }}</span>
          <span class="suggestnoText">{{e.userType == '2' ? '股东' : '' }}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'SelectInputs',
  props: [
    'params',
    'form',
    'errorMessage',
    'allowClearHandler',
    'placeholder',
    'maxlength',
    'type',
    'disabled',
    'value',
    'label',
    'labelWidth',
    'border',
    'prop',
    'separate',
    'readonly',
    'toUpperCase',
  ],
  data() {
    return {
      col: '',
      isDelete: false,
      error: '',
      suggestList: [],
      flag: false,
      beforeList: [],
      rows: 1,
    };
  },
  computed: {
    isSelectInput() {
      return this.flag && this.col;
    },
  },
  watch: {
    readonly: {
      handler(val) {
        // eslint-disable-next-line no-unused-expressions
        !val ? (this.isDelete = false) : '';
      },
      immediate: true,
    },
    col: {
      handler(newVal, oldVal) {
        this.rows = Math.ceil(newVal.length / 9) || 1;
        this.$emit('input', newVal);
      },
      immediate: true,
    },
    errorMessage: {
      handler(val) {
        this.error = val.message;
      },
    },
    'params.initValue': {
      handler(val) {
        this.col = val;
      },
    },
  },
  mounted() {
    window.document.getElementById('app').addEventListener('click', (e) => {
      this.flag = false;
      this.suggestList = [];
    });
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    focusHandler() {
      if (this.col === '') {
        this.getBindingEnterprise();
      }
    },
    getBindingEnterprise() {
      this.$api.PublicPage.getBindingEnterprise({
        productId: this.$route.query.productId,
      }).then((res) => {
        this.beforeList = [];
        res.data.forEach((v) => {
          this.beforeList.push({
            ...v,
            credit_no: v.taxNo,
            name: v.corpName,
          });
        });
        this.suggestList = this.beforeList;
        this.flag = true;
      });
    },
    clickDelete() {
      this.col = '';
    },
    debounce(fn, delay) {
      if (this.time !== null) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => {
        fn.call(this);
      }, delay);
    },
    handleinput() {
      this.debounce(async () => {
        this.getSuggest();
      }, 1000);
    },
    getSuggest() {
      if (this.col === '') {
        this.focusHandler();
        return;
      };
      this.$api.PublicPage.getSuggest({
        searchkey: this.col,
        count: 5,
      }).then((res) => {
        if (res.status === 200) {
          const { data = [] } = res;
          this.suggestList = data || [];
          this.flag = true;
        }
      });
    },
    handleSuggest(e) {
      this.form.setInitialValues({
        taxNo: e.credit_no,
        borrowerType: e.userType || 3,
      });
      this.updateState({
        borrowerType: e.userType,
      });
      this.col = e.name;
      this.$emit('input', e.name);
      this.flag = false;
      this.suggestList = [];
    },
  },
};
</script>
<style scoped lang="scss">
.SelectInputs {
  position: relative;
  display: flex;
  background: #fff;
  padding: 11px 16px;
  position: relative;
  justify-content: start;
  align-items: center;
}
input {
  border: 0;
  font-size: 16px;
  padding: 0;
  margin: 0;
}
.title {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #46494d;
  font-weight: 400;
  width: 86px;
  margin-right: 16px;
  text-align: start;
  margin-bottom: 0;
}
.error-message {
  position: absolute;
  top: 26px;
  left: 115px;
  color: red;
  font-size: 12px;
  text-align: left;
}
.input_box {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.cross {
  position: absolute;
  right: 16px;
  color: #9e9fa0;
}
.SelectInputs >>> input::-webkit-input-placeholder {
  font-size: 16px;
  color: #bcc2cc;
  line-height: 24px;
  font-weight: 400;
}
.SelectInputs >>> input::-moz-input-placeholder {
  font-size: 16px;
  color: #bcc2cc;
  line-height: 24px;
  font-weight: 400;
}
.SelectInputs >>> input::-ms-input-placeholder {
  font-size: 16px;
  color: #bcc2cc;
  line-height: 24px;
  font-weight: 400;
}
input:disabled {
  background-color: #fff !important;
}
.SelectInput {
  position: absolute;
  left: 0;
  top: 41px;
  z-index: 2;
  width: 100%;
  max-height: 300px;
  background: #fff;
  overflow: scroll;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
}
.suggestName {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #7c8693;
}
.suggestno {
  font-family: PingFangSC-Regular;
  color: #b9b9b9;
  letter-spacing: 0;
  font-size: 12px;
}
.suggestnoText {
  font-family: PingFangSC-Regular;
  color: #b9b9b9;
  letter-spacing: 0;
  font-size: 12px;
  margin-left: 3px;
}
.suggestList {
  padding: 8px;
  border-bottom: 1px solid #eee;
  text-align: left;
}
.suggestList:active {
  background: #eee;
}
.select {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #f55646;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.Input {
  width: 195px;
}
</style>
